import React from 'react'
import "./Adults.scss"

function Adults() {
  return (
    <div>Adults</div>
  )
}

export default Adults